import { Directive, Optional } from "@angular/core";
import { ExpandableRowsCount } from "./providers/global-expandable-rows";
/*
 * I don't think this deserves to be in IfExpanded itself,
 * so I'm adding a second directive on the same selector for now just for the datagrid
 */
var DatagridDetailRegisterer = (function () {
    function DatagridDetailRegisterer(expandableRowsCount) {
        this.expandableRowsCount = expandableRowsCount;
        if (this.expandableRowsCount) {
            this.expandableRowsCount.register();
        }
    }
    DatagridDetailRegisterer.prototype.ngOnDestroy = function () {
        if (this.expandableRowsCount) {
            this.expandableRowsCount.unregister();
        }
    };
    return DatagridDetailRegisterer;
}());
export { DatagridDetailRegisterer };
DatagridDetailRegisterer.decorators = [
    { type: Directive, args: [{
                selector: "[clrIfExpanded]"
            },] },
];
/** @nocollapse */
DatagridDetailRegisterer.ctorParameters = function () { return [
    { type: ExpandableRowsCount, decorators: [{ type: Optional },] },
]; };
//# sourceMappingURL=datagrid-detail-registerer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/datagrid-detail-registerer.js
// module id = 288
// module chunks = 4